import { Component, OnInit } from '@angular/core';
import {FacilityService} from '../../shared/services/facility.service';
import {AlertService} from '../../shared/services/alert.service';
import {OrphanInspectionFacility} from '../../models/ApplicationModel';

@Component({
  selector: 'app-facility-user-association',
  templateUrl: './legacy-data-user-association.component.html',
  styleUrls: ['./legacy-data-user-association.component.css', '../../facility/facility-categorize/facility-categorize.component.css']
})
export class LegacyDataUserAssociationComponent implements OnInit {

  public searchString = '';
  public facilities: OrphanInspectionFacility[] = [];
  public selectedFacility: OrphanInspectionFacility;

  constructor(private facilityService: FacilityService,
              private alertService: AlertService) { }

  ngOnInit() {
    this.getFacilityList();
  }

  getFacilityList() {
    this.facilityService.getOrphanInspectionFacilityList().subscribe(
      res => {
        this.facilities = res;
      },
      err => {
        this.alertService.error('Error fetching facilities. Please try again later');
      }
    );
  }
  facilityRowClicked(facility) {
    this.selectedFacility = Object.assign({}, facility);
  }

  saveFacilityEmail() {
    let facilityModel: any = {};
    facilityModel.facilityID = this.selectedFacility.facilityID;
    facilityModel.email = this.selectedFacility.facilityEmail ? this.selectedFacility.facilityEmail.trim() : '';
    facilityModel.typeID = this.selectedFacility.typeID;
    this.facilityService.changeInspectionFacilityEmail(facilityModel).subscribe(
      res => {
        if (res) {
          this.alertService.success('Successfully changed facility email');
          const updatedFacility = this.facilities.find(fac => fac.facilityID === facilityModel.facilityID);
          updatedFacility.facilityEmail = facilityModel.email;
        } else {
          this.alertService.error('Changing facility email failed. Please try again later');
        }
    }, err => {
        this.alertService.error('Changing facility email failed. Please try again later');
      }
    );
  }
  clearSearchString() {
    this.searchString = '';
  }
}


